<script setup lang="ts">
definePage({
	name: "auth.login",
	meta: {
		name: "Login",
	},
});
</script>

<template>
	<div id="login-page">
		<div class="image-section">
			<img
				alt="placeholder-image"
				src="@/assets/image/login-image.png"
			/>
		</div>
		<div class="comp-section">
			<login-comp></login-comp>
		</div>
	</div>
</template>

<style lang="scss" scoped>
#login-page {
	display: flex;
	flex-direction: column;
	gap: 40px;
	height: 100%;
	width: 100%;

	.image-section,
	.comp-section {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		max-width: 620px;
		margin: 0 auto;

		.login {
			width: 100%;
		}
	}

	.image-section {
		flex-direction: column;
		align-items: flex-start;
		gap: 20px;

		.title {
			font-family: Anton, sans-serif;
			font-size: clamp(1rem, 4vw, 60px);
			font-style: normal;
			font-weight: 400;
		}

		.desc {
			font-family: "Open Sans", sans-serif;
			font-size: clamp(0.8rem, 3.5vw, 24px);
			font-style: normal;
			font-weight: 400;
			line-height: normal;
		}

		img {
			width: 100%;
			max-width: 900px;
		}
	}

	@media screen and (width > 768px) {
		.image-section {
			flex-basis: 80%;
			padding: 0;
		}
		.comp-section {
			min-width: 400px;

			> * {
				width: 100%;
			}
		}
	}

	@media screen and (width > 1156px) {
		gap: 40px;
		flex-direction: row;
		justify-content: space-between;

		.image-section {
			max-width: 800px;
		}
		.comp-section {
			max-width: 400px;
		}
	}

	@media screen and (width > 1500px) {
		gap: 40px 170px;
	}
}
</style>
